// 登录
import service from '@/utils/request'

export function adminuserLimits (data) {
  return service({
    url: '/service/admin/adminuser_limits',
    method: 'post',
    params: data
  })
}
export function addSdminuser (data) {
  return service({
    url: '/service/admin/add_adminuser',
    method: 'post',
    params: data
  })
}
export function updateAdminuserlimit (data) {
  return service({
    url: '/service/admin/update_adminuserlimit',
    method: 'post',
    params: data
  })
}
export function adminuserList (data) {
  return service({
    url: '/service/admin/adminuser_list',
    method: 'post',
    params: data
  })
}
export function adminuserSetstatusval (data) {
  return service({
    url: '/service/admin/adminuser_setstatusval',
    method: 'post',
    params: data
  })
}
export function adminuserDel (data) {
  return service({
    url: '/service/admin/adminuser_del',
    method: 'post',
    params: data
  })
}
export function adminuserView (data) {
  return service({
    url: '/service/admin/adminuser_view',
    method: 'post',
    params: data
  })
}
export function updateAdminuser (data) {
  return service({
    url: '/service/admin/update_adminuser',
    method: 'post',
    params: data
  })
}

export function businessStatistics (data) {
  return service({
    url: 'service/admin/business_statistics',
    method: 'post',
    params: data
  })
}
